import Model  from '@/util/models';
import Dapil  from './Dapil';
import Partai from './Partai';
import axios  from 'axios';
import config from '@/config'
import tc     from '@/util/thencatch'

let kpu =  axios.create({baseURL: config.kpu});  

export default class Matching extends Model { 
    backend = '/frc/dashboard/'; 
       
    surat(params, firstime){
        return this.api.get(firstime ? '/frc/hitung/surat':'/frc/hitung/surat-min', params);
    }   
    
    getC1Download(params){
        return this.api.get('/frc/hitung/c1-download', params);
    }
       
    kompetisis(params){
        return this.api.get(this.backend + 'kompetisis', params);
    }
    
    kompetisi(params){
        return this.api.get(this.backend + 'kompetisinolimit', params);
    }
    
    areas(params){
        return this.api.get(this.backend + 'areasnolimit', params);
    }
    
    dapils(params){
        return this.api.get(this.backend + 'dapils', params);
    }    
    
    calegs(params){
        return this.api.get(this.backend + 'calegs', params);
    } 
        
    partais(params){
      let model = new Partai();
      return model.all(params);
    }
    
    getImg(params){
        return this.api.get('/frc/image/get-img', params);
    }
    
    getThumb(params){
        return this.api.get('/frc/image/get-thumb', params);
    }
    
    kpuJson(r){
        return tc(kpu.get('static/json/'+r));
    }

    kpuImgUrl(r){
        return config.kpu+'img/c/'+r;
    }
}

